<div
  class="content col-md-8 col-md-offset-2 col-sm-offset-2 shadowBoxBg"
  style="margin-left: 16.66666667%; margin-top: 20px;"
>
  <div class="navyCashHeading" style="padding-left: 20px;">
    EagleCash Privacy Notices
  </div>
  <div class="full_container privacy_policy">
    <div style="width: 100%; text-align: right; margin-bottom: -35px;">
      Rev. June 2026
    </div>
    <img class="pnc_logo" src="assets/img/pnc.png" />
    <table cellspacing="0" cellpadding="0" class="policy">
      <tr>
        <td class="t_header">
          PNC BANK PREPAID CARD CONSUMER INFORMATION PRIVACY NOTICE
        </td>
      </tr>
      <tr>
        <td class="t_content">
          These disclosures are made on behalf of PNC Bank, National Association
          (PNC).
          <br /><br />
          PNC is committed to treating and using personal financial information
          about you responsibly.
        </td>
      </tr>
      <tr>
        <td class="t_content">
          PNC collects information about Prepaid Card holders from the following
          sources:
          <ul>
            <li>
               Information you provide in the Prepaid Card Enrollment Form and
               other forms
            </li>
            <li>Information obtained from your employer or card sponsor</li>
          </ul>
          PNC does not share personal information about Prepaid Card holders or
          former Prepaid Card holders with affiliates or nonaffiliated third
          parties, except as permitted by law.
        </td>
      </tr>
      <tr>
        <td class="t_content">
          To protect your personal information from unauthorized access and use,
          PNC uses security measures that comply with federal law. These
          measures include computer safeguards and secured files and buildings.
          Additionally, PNC requires and trains its employees to comply with its
          privacy standards and policies, which are designed to protect customer
          information.
        </td>
      </tr>
      <tr>
        <td>
          <table width="100%">
            <tr>
              <td width="20%" class="t_header">Questions?</td>
              <td class="t_content">Call 1-888-762-2265</td>
            </tr>
          </table>
        </td>
      </tr>
    </table>
    <a href="../assets/navy-cash-ca-privacy-notice-long.pdf" target="_blank"
      >California Consumer Privacy Act Privacy Notice</a
    >
  </div>
</div>
